import { Grid, Typography, Box, TextField, Button } from '@mui/material';
import { useState } from 'react';
import emailjs from 'emailjs-com';
import { getImageUrl } from '../../utils';

const contactImage = getImageUrl('about-quote.png');

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_0dt32u7';
    const templateID = 'template_zvbgn39';
    const userID = 'SxRsBdlgUaGAGjDZh';

    const templateParams = {
      to_name: 'Pilates Höganäs',
      from_name: formData.name,
      from_phone: formData.phone,
      from_email: formData.email,
      message: formData.message,
    };

    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then(() => {
        alert('Tack! Meddelandet är skickat.');
        setFormData({ name: '', email: '', phone: '', message: '' });
      })
      .catch(() => {
        alert('Något gick fel. Försök igen.');
      });
  };

  return (
    <Box sx={{ background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)', py: { xs: 6, md: 8 } }}>
      <Grid container spacing={6} justifyContent="center" alignItems="center">
        {/* Form */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              background: 'rgba(255, 255, 255, 0.6)',
              backdropFilter: 'blur(8px)',
              borderRadius: '1rem',
              px: { xs: 3, md: 5 },
              py: { xs: 4, md: 6 },
              boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                mb: 2,
                color: '#222',
                textAlign: 'center',
                fontSize: { xs: '1.75rem', md: '2.25rem' },
              }}
            >
              Kontakta oss
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                mb: 4,
                color: '#444',
                fontSize: '1rem',
              }}
            >
              Fyll i formuläret nedan så återkommer vi till dig inom kort.
            </Typography>

            <Box component="form" onSubmit={handleSubmit}>
              {['name', 'email', 'phone'].map((field, i) => (
                <TextField
                  key={i}
                  fullWidth
                  label={field === 'name' ? 'Namn' : field === 'email' ? 'Email' : 'Telefonnummer'}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    mb: 2,
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.06)',
                  }}
                />
              ))}
              <TextField
                fullWidth
                label="Meddelande"
                name="message"
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={4}
                variant="outlined"
                sx={{
                  mb: 3,
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.06)',
                }}
              />
              <Box textAlign="center">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    background: 'linear-gradient(135deg, #00b5bf, #429398)',
                    color: '#fff',
                    fontWeight: 600,
                    px: 4,
                    py: 1.5,
                    borderRadius: '999px',
                    textTransform: 'none',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                     '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
                  }}
                >
                  Skicka Meddelande
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Image */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: 300, md: 450 },
              borderRadius: '1rem',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              backgroundImage: `url(${contactImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contact;
